import { useEffect, useState } from 'react';
import client from '../feathers';
import { getAnonAddresses } from '../util/connections';
import { isTokenValid } from '../util/token';
import useWalletError from '../hooks/useWalletError';
import useAuth from '../hooks/useAuth';
import useIntl from '../hooks/useIntl';
import { useProgressDialog } from '../context/ProgressDialogProvider';
import useSentry from '../hooks/useSentry';

export const useBills = (filter, search, doRefreshBills, doGrouping) => {
  const [state, setState] = useState({
    bills: undefined,
    anonAddresses: [],
  });

  const onWalletError = useWalletError();
  const { user } = useAuth();
  const { showProgressDialog, hideProgressDialog } = useProgressDialog();
  const { translate } = useIntl();
  const logSentry = useSentry();

  const fetchBills = async () => {
    if (!isTokenValid()) {
      onWalletError(new Error(translate('session.expired')));
      return;
    }
    
    // Erase any data from search of filter that would be still showing underneath the progress dialog to avoid confusion
    // "bills" also shouldn't be an empty array, because then the message "No data found is shown", which also might be confusing...
    if (user.features.canSkipInitialLoad) {
      setState({ ...state, bills: [{}] });
    }

    showProgressDialog();
    let { anonAddresses } = state;
    if (anonAddresses.length === 0) {
      try {
        anonAddresses = await getAnonAddresses(user);
      } catch (error) {
        onWalletError(error);
      }
    }

    const { data } = await client.service('bills-of-lading').find({
      query: {
        addresses: anonAddresses,
        doGrouping: doGrouping,
        $filter: filter,
        $search: search
      },
    });

    hideProgressDialog()
    setState({ ...state, anonAddresses, bills: data });
  };

  useEffect(() => {
    try {
      doRefreshBills && fetchBills();
    } catch (e) {
      logSentry(e);
      onWalletError(e);
    } 
  }, [filter, search, doRefreshBills, doGrouping]);

  useEffect(() => {
    console.log("anonAddresses", state.anonAddresses)
  }, [state.anonAddresses]);

  return { ...state };
};
